import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoldReportDesignerModule } from './reportdesigner.module';
import { BoldReportViewerModule } from './reportviewer.module';
export class BoldReportsModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    BoldReportViewerModule,
    BoldReportDesignerModule
  ],
  declarations: [
  ],
  exports: [
    BoldReportViewerModule,
    BoldReportDesignerModule
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BoldReportsModule_tsickle_Closure_declarations() {
/** @type {?} */
BoldReportsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoldReportsModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
